export enum widgetRequestTypes {
  getAulaToken = 'getAulaToken',
  triggerStepUp = 'triggerStepUp',
  getProps = 'getProps',
  setIframeHeight = 'setIframeHeight',
  deleteNotifications = 'deleteNotifications',
}
